import React from "react";
import { Col } from "react-bootstrap";

const Radio = ({ attendee, onChange }) => {
  const { id, value, label, name, checked } = attendee;
  return (
    <Col>
      <div>
        <input
          checked={checked}
          type="radio"
          name={name}
          value={value}
          id={id}
          className="visually-hidden"
          onChange={(event) => onChange(event)}
        />
        <label
          htmlFor={id}
          className="switch-label checkbox-label text-center"
        >
          {label}
        </label>
      </div>
    </Col>
  );
};

export default Radio;
